import { render, staticRenderFns } from "./browse-recently-played-mixes.vue?vue&type=template&id=80e0d2e2"
import script from "./browse-recently-played-mixes.vue?vue&type=script&setup=true&lang=js"
export * from "./browse-recently-played-mixes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports